const base = '@@Containers/ResetPassword/';

export const UPDATE_FORM_VALUES = `${base}UPDATE_FORM_VALUES`;
export const TOGGLE_LOADER = `${base}TOGGLE_LOADER`;
export const RESET_STATE = `${base}RESET_STATE`;

